module.exports = __webpack_public_path__ + "static/img/4b807f671fdf1e3cfe97.86d8a0e5.jpg";